<template>
  <layout-default>
    <div id="patient" class="v-inner--wrap">
      <v-overlay :value="loading" z-index="4">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <inner-drawer :routes="getPatientMenu">
        <template v-slot:header>
          <patient-card v-bind:patient="currentPatient" />
        </template>
      </inner-drawer>
      <inner-content />
    </div>
  </layout-default>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import InnerDrawer from '@/components/InnerDrawer.vue'
import InnerContent from '@/components/InnerContent.vue'
import PatientCard from '@/components/patients/PatientCard.vue'
import { protectedRoute } from '@/router/config'
import LayoutDefault from '../layouts/LayoutDefault.vue'
import TenantTextsMixin from '@/mixins/tenantTexts'

export default {
  name: 'Patient',
  components: {
    InnerDrawer,
    InnerContent,
    PatientCard,
    LayoutDefault,
  },
  mixins: [
    TenantTextsMixin
  ],
  computed: {
    ...mapState('patientsStates', ['currentPatient', 'loading']),
    ...mapGetters('patientsStates', ['patientProgram', 'patientProgramName']),
    ...mapState('dictionariesStates', ['dictionaryFeatureFlagState']),
    getPatientMenu() {
      let patientRoutes = []
      let hiddenRoutes = []

      if (protectedRoute) {
        patientRoutes = protectedRoute.find(el => el.name === 'Patient')

        if (patientRoutes && patientRoutes.children) {
          patientRoutes = patientRoutes.children
        }
      }

      return Array.isArray(patientRoutes)
        ? patientRoutes.filter(route =>
            route.meta ? !hiddenRoutes.includes(route.meta.menuTitle) : true,
          )
        : []
    },
    getFullPath() {
      return this.$route.path
    },
  },
  beforeRouteLeave: function(to, from, next) {
    this.$store.commit('patientsStates/updateCurrentPatient', {})
    next()
  },
  data: () => ({}),
  watch: {
    getFullPath() {},
    $route (to, from) {
      // get new current patient data when patient id changed
      if (to.params?.id !== undefined && from.params?.id !== to.params?.id) {
        this.getPatient(to.params.id)
      }
    }
  },
  methods: {
    ...mapActions('patientsStates', ['getPatient']),
  },
  mounted: function() {
    this.getPatient(this.$route.params.id)
  },
}
</script>
